import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component, Fragment } from 'react';
var css = {
  "nav": "rui-ofCOm",
  "pagination": "rui-j1fQU",
  "paginationItem": "rui-cToPo",
  "arrowRight": "rui-LocZv",
  "arrowLeft": "rui-iAb4Z"
};
import PageItem from './PageItem';
import PageDots from './PageDots';
import PageArrow from './PageArrow';
export var DEFAULT_PAGE_SIZE = 20;
var DOTS = 'DOTS';
var range = function range(from, to) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = from;
  var range = [];
  while (i <= to) {
    range.push(i);
    i += step;
  }
  return range;
};
var Pagination = /*#__PURE__*/function (_Component) {
  _inherits(Pagination, _Component);
  var _super = _createSuper(Pagination);
  function Pagination(props) {
    var _this;
    _classCallCheck(this, Pagination);
    _this = _super.call(this, props);
    _this.gotoPage = function (page) {
      var _this$props$onPageCha = _this.props.onPageChanged,
        onPageChanged = _this$props$onPageCha === void 0 ? function (f) {
          return f;
        } : _this$props$onPageCha;
      var currentPage = Math.max(0, Math.min(page, _this.totalPages));
      var paginationData = {
        currentPage: currentPage,
        totalPages: _this.totalPages,
        pageSize: _this.pageSize,
        totalRecords: _this.totalRecords
      };
      _this.setState({
        currentPage: currentPage
      }, function () {
        return onPageChanged(paginationData);
      });
    };
    _this.handleClick = function (page) {
      return function (evt) {
        evt.preventDefault();
        _this.gotoPage(page);
      };
    };
    _this.handleMoveLeft = function (evt) {
      evt.preventDefault();
      _this.gotoPage(_this.state.currentPage - 1);
    };
    _this.handleMoveRight = function (evt) {
      evt.preventDefault();
      _this.gotoPage(_this.state.currentPage + 1);
    };
    _this.getPages = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        totalPages = _assertThisInitialize.totalPages;
      var currentPage = _this.state.currentPage;
      var _this$props = _this.props,
        pageNeighbours = _this$props.pageNeighbours,
        pageOffset = _this$props.pageOffset;
      var totalNumbers = pageNeighbours * 2 + 3;
      var totalBlocks = totalNumbers + 2;
      if (totalPages > totalBlocks) {
        var startPage = Math.max(2, currentPage - pageNeighbours);
        var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
        var pages = range(startPage, endPage);
        var hasLeftSpill = startPage > 2;
        var hasRightSpill = totalPages - endPage > 1;
        if (hasLeftSpill && !hasRightSpill) {
          var extraPages = range(startPage - pageOffset, startPage - 1);
          pages = [DOTS].concat(_toConsumableArray(extraPages), _toConsumableArray(pages));
        } else if (!hasLeftSpill && hasRightSpill) {
          var _extraPages = range(endPage + 1, endPage + pageOffset);
          pages = [].concat(_toConsumableArray(pages), _toConsumableArray(_extraPages), [DOTS]);
        } else if (hasLeftSpill && hasRightSpill) {
          pages = [DOTS].concat(_toConsumableArray(pages), [DOTS]);
        }
        return [1].concat(_toConsumableArray(pages), [totalPages]);
      }
      return range(1, totalPages);
    };
    var total = props.total,
      pageSize = props.pageSize,
      selectedPage = props.selectedPage;
    _this.pageSize = typeof pageSize === 'number' ? pageSize : DEFAULT_PAGE_SIZE;
    _this.totalRecords = typeof total === 'number' ? total : 0;
    _this.totalPages = Math.ceil(_this.totalRecords / _this.pageSize);
    _this.state = {
      currentPage: selectedPage
    };
    return _this;
  }
  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.totalRecords || this.totalPages === 1) {
        return null;
      }
      var dataAutId = this.props['data-aut-id'];
      var currentPage = this.state.currentPage;
      var pages = this.getPages();
      var firstPage = pages[0];
      var lastPage = pages[pages.length - 1];
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("nav", {
        "data-aut-id": dataAutId,
        className: css.nav
      }, /*#__PURE__*/React.createElement("ul", {
        className: css.pagination
      }, /*#__PURE__*/React.createElement("li", {
        className: css.arrowLeft,
        key: "leftArrow"
      }, /*#__PURE__*/React.createElement(PageArrow, {
        "data-aut-id": "arrowLeft",
        icon: "arrowLeft",
        onClick: this.handleMoveLeft,
        disable: currentPage === firstPage
      })), pages.map(function (page, index) {
        if (page === DOTS) {
          return /*#__PURE__*/React.createElement("li", {
            className: css.paginationItem,
            key: "dots-".concat(index)
          }, /*#__PURE__*/React.createElement(PageDots, {
            "data-aut-id": "pageDots"
          }));
        }
        return /*#__PURE__*/React.createElement("li", {
          className: css.paginationItem,
          key: index
        }, /*#__PURE__*/React.createElement(PageItem, {
          "data-aut-id": "pageItem",
          key: index,
          selected: currentPage === page,
          onClick: _this2.handleClick(page)
        }, page));
      }), /*#__PURE__*/React.createElement("li", {
        className: css.arrowRight,
        key: "rightArrow"
      }, /*#__PURE__*/React.createElement(PageArrow, {
        "data-aut-id": "arrowRight",
        icon: "arrowRight",
        disable: currentPage === lastPage,
        onClick: this.handleMoveRight
      })))));
    }
  }]);
  return Pagination;
}(Component);
Pagination.defaultProps = {
  'data-aut-id': 'pagination',
  pageSize: DEFAULT_PAGE_SIZE,
  pageNeighbours: 2,
  pageOffset: 2,
  total: null,
  selectedPage: 1
};
export default Pagination;